import { useParams, useLocation } from "react-router-dom";
import Loader from "../../component/ui/Loader.js";
import MovieDetails from "./MovieDetails.js";
import { useGetMovieDetailsQuery } from "../../services/modulesuser/movieDetails/index.js";

function MovieDetailsPage() {
    const { id } = useParams();
    const location = useLocation();
    const passedVideo = location.state?.video;
    const { data: movie, isLoading, error } = useGetMovieDetailsQuery(id);
    const video = movie?.data?.result
    if (isLoading) return <Loader />;
    if (error || !movie)
        return <div className="text-red-500">{error || "Movie not found"}</div>;
    return <MovieDetails movie={video} />;
}

export default MovieDetailsPage;
